// extracted by mini-css-extract-plugin
export var textarea = "textarea-module--textarea--D+4xO";